import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { throwError, BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpService } from '../utils/services/http.service';
import { ErrorService } from '../utils/services/error.service';

// @Injectable({
//   providedIn: "root",
// })
// export class AppCommonService {
//   constructor() { }
//   private routingData = [
//     { order: 1, moduleName: "Dashboard", routerLink: "/dashboard" },
//     { order: 2, moduleName: "Leads", routerLink: "/leadmanagement" },
//     { order: 3, moduleName: "Manage Users", routerLink: "/usermanagement" },
//     { order: 4, moduleName: "Manage Roles", routerLink: "/rolemanagement" },
//   ];
//   /* get all the routing/module details */
//   getRoutingData() {
//     return this.routingData;
//   }
// }
@Injectable()
export class AppCommonService {

  constructor(
    private httpService: HttpService,
    private errService: ErrorService
  ) { }
  login(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data)
      .pipe(
        map((res: Response) => {
          return (res.hasOwnProperty('body') ? res.body : res);
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.hasOwnProperty('error') ? error.error : error);
        })
      );
  }
  update(url: any, data: any): Observable<any> {
    return this.httpService.put(url, data)
      .pipe(
        map((res: Response) => {
          return (res.hasOwnProperty('body') ? res.body : res);
        }),
        catchError(error => {
          // this.sharedService.display(false);
          this.errorHandler(error);
          return throwError(error.hasOwnProperty('error') ? error.error : error);
        })
      );
  }
  getAddress(url: any): Observable<any> {
    return this.httpService.getIP(url).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }
  errorHandler(error: any) {
    this.errService.handleError(error);
  }
}

